import React from 'react';
import Button from 'epn-ui/umd/dist/components/Button';
import { faTelegramPlane } from '@fortawesome/free-brands-svg-icons/faTelegramPlane';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useI18n from '@i18n';
import { companyName } from '@config/globalDomain';
import BaseGrid from '../../../base/BaseGrid';
import BaseContainer from '../../../base/BaseContainer';

import MockupsImg from './images/Mockups.png';

interface IPresentBlock {
    auth?: boolean;
    goToCopyLink: () => void;
    goAuth: () => void;
    goReg: () => void;
}

const PresentBlock: React.FC<IPresentBlock> = ({ auth = false, goToCopyLink, goAuth, goReg }) => {
    const { t, locale } = useI18n('TelegramBot');

    return (
        <BaseContainer>
            <div className="flex flex-col justify-center w-full h-[40vh] min-h-[400px] sm:min-h-[590px] md:min-h-[530px] lg:min-h-[590px] xl:min-h-[720px]">
                <div className="flex md:px-0 lg:h-[315px] xl:h-[420px]">
                    <BaseGrid item lg={6} initial={0}>
                        {/* eslint-disable-next-line jsx-a11y/img-redundant-alt */}
                        <img
                            src={MockupsImg}
                            className="lg:w-[545px] lg:ml-[-62px] md:ml-[-62px] xl:w-[722px] xl:-ml-[78px]"
                            alt="Mockup image"
                        />
                    </BaseGrid>
                    <BaseGrid item lg={6}>
                        <div className="flex items-center justify-center w-full h-full">
                            <BaseGrid item initial={12}>
                                <h1 className="mb-4 font-medium text-[28px] xs:text-[28px] sm:text-[28px] xs:leading-[42px] lg:text-[40px] lg:leading-[50px] text-blueGray-800">
                                    {t('Telegram bot ePN Affiliate', { companyName })}
                                </h1>
                                <p className="text-sm text-[#475569] xs:mb-8 xs:text-base md:text-[18px] lg:mb-12">
                                    {t(
                                        'Create affiliate links on quick by using any device and connect assistants to create affiliate links',
                                    )}
                                </p>
                                <div>
                                    {!auth && (
                                        <div className="flex flex-col items-start w-full mt-[24px] xs:space-x-6 xs:mt-[33px] xs:items-center xs:flex-row">
                                            <Button
                                                type="primary"
                                                onClick={goAuth}
                                                className="w-full xs:w-auto"
                                            >
                                                {t('Log in to your account')}
                                            </Button>
                                            <Button
                                                className="w-full mt-[16px] xs:ml-[24px] xs:mt-0 xs:w-auto"
                                                onClick={goReg}
                                            >
                                                {t('Registration')}
                                            </Button>
                                        </div>
                                    )}
                                    {auth && (
                                        <div className="flex flex-col items-start w-full mt-[24px] xs:space-x-6 xs:mt-[33px] xs:items-center xs:flex-row">
                                            <Button
                                                type="primary"
                                                className="w-full bg-sky-500 hover:bg-sky-500 xs:w-auto"
                                                style={{ background: '#0ea5e9' }}
                                                iconPosition="start"
                                                icon={<FontAwesomeIcon icon={faTelegramPlane} />}
                                                onClick={goToCopyLink}
                                            >
                                                {t('Get the link')}
                                            </Button>
                                            {locale === 'ru' && (
                                                <Button
                                                    href="/ePNTelegramBotGuide.pdf"
                                                    style={{
                                                        color: '#0ea5e9',
                                                        borderColor: '#0ea5e9',
                                                    }}
                                                    className="w-full mt-[16px] xs:w-auto xs:ml-[24px] xs:mt-0 text-sky-500 border-sky-500 hover:text-sky-500 hover:border-sky-500 hover:bg-white"
                                                    icon={<FontAwesomeIcon icon={faQuestion} />}
                                                    iconPosition="start"
                                                >
                                                    {t('How it works?')}
                                                </Button>
                                            )}
                                        </div>
                                    )}
                                </div>
                                {!auth && (
                                    <p className="mt-4 text-xs text-brandBlue-300 xs:mt-3 xs:text-sm">
                                        {t(
                                            'To get a link to the bot, please log in to the service',
                                        )}
                                    </p>
                                )}
                            </BaseGrid>
                        </div>
                    </BaseGrid>
                </div>
            </div>
        </BaseContainer>
    );
};

export default PresentBlock;
